import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { KibSpinner } from '@chewy/kib-interstitials-react'

import { ContextualBackButton } from '~/components/common/buttons/ContextualBackButton'
import { RightRailOverlayProvider } from '~/components/dashboard/soapV2/context/RightRailOverlayContext'
import { PatientMedicalSummaryRail } from '~/components/dashboard/soapV2/summary/PatientMedicalSummaryRail'

import ClientAndPatientSection from './details/new-client-and-patient/ClientAndPatientSection'
import { useRxTimelineItem } from './hooks/useRxTimelineItem'
import { RxCardDetails } from './timeline/prescriptions/rxTracker/RxCardDetails'
import RxCardHeader from './timeline/RxCardHeader'

import '@chewy/kib-interstitials-styles/dist/styles/kib-spinner.css'
import styles from './PrescriptionDetailsPage.module.scss'

const PrescriptionDetailsPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('Common')
  const { prescriptionId } = useParams()

  const { timelineItem, clientId, patientId, loading } =
    useRxTimelineItem(prescriptionId)

  const handleBackNavigation = () => {
    if (clientId && patientId) {
      navigate(`/client/${clientId}/patient/${patientId}`)
    } else if (clientId) {
      navigate(`/client/${clientId}`)
    } else {
      navigate(-1)
    }
  }

  return (
    <div className={styles.root}>
      {clientId && (
        <div className={styles.clientSection}>
          <ClientAndPatientSection clientId={clientId} patientId={patientId} />
        </div>
      )}
      <div className={styles.mainContent}>
        <ContextualBackButton
          buttonText={t('Common:CLIENT_AND_PATIENT_DETAIL')}
          navigateBackToContext={handleBackNavigation}
        />
        <div className={styles.content}>
          <div className={styles.header}>
            {loading && (
              <div className={styles.loading}>
                <KibSpinner />
              </div>
            )}
            {!loading && timelineItem && (
              <div className={styles.rxContainer}>
                <RxCardHeader timelineItem={timelineItem} />
                <div className={styles.rxDetailsContainer}>
                  <RxCardDetails isDetailView item={timelineItem} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {clientId && (
        <div className={styles.rightRail}>
          <RightRailOverlayProvider>
            <PatientMedicalSummaryRail
              clientId={clientId}
              patientId={patientId}
            />
          </RightRailOverlayProvider>
        </div>
      )}
    </div>
  )
}

export { PrescriptionDetailsPage }
